import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAppStore } from '@/store'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const app = useAppStore()
const { mobileScreenMode, padScreenMode, padHorScreenMode, desktopScreenMode } = storeToRefs(app)

onMounted(() => {
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 768) {
      mobileScreenMode.value = true
      padScreenMode.value = false
      padHorScreenMode.value = false
      desktopScreenMode.value = false
    } else if (window.innerWidth <= 992) {
      mobileScreenMode.value = false
      padScreenMode.value = true
      padHorScreenMode.value = false
      desktopScreenMode.value = false
    } else if (window.innerWidth <= 1200) {
      mobileScreenMode.value = false
      padScreenMode.value = false
      padHorScreenMode.value = true
      desktopScreenMode.value = false
    } else if (window.innerWidth <= 1920) {
      mobileScreenMode.value = false
      padScreenMode.value = false
      padHorScreenMode.value = false
      desktopScreenMode.value = true
    } else {
      mobileScreenMode.value = false
      padScreenMode.value = false
      padHorScreenMode.value = false
      desktopScreenMode.value = false
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})